var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGasStation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.926,
    height: 12.896,
    viewBox: "0 0 13.926 12.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9,11.25h3.611v1.032H9Z",
    transform: "translate(-5.905 -7.639)",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.874,5.954,13.3,3.375l-.729.729,1.547,1.547V8.017a1.032,1.032,0,0,0,1.032,1.032v5.416a.774.774,0,0,1-1.547,0V10.08a.516.516,0,0,0-.516-.516H11.018V4.407a.516.516,0,0,0-.516-.516H3.8a.516.516,0,0,0-.516.516V15.238H2.25V16.27h9.8V15.238H11.018V10.6h1.547v3.817a1.838,1.838,0,0,0,1.426,1.818,1.808,1.808,0,0,0,2.184-1.767V6.683a1.032,1.032,0,0,0-.3-.729ZM9.987,15.238H4.313V4.922H9.987Z",
    transform: "translate(-2.25 -3.375)",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasStation);
export default __webpack_public_path__ + "static/media/gas-station.0e1c42e759e90242b6adda224ad4d4e2.svg";
export { ForwardRef as ReactComponent };